import React from 'react';
import './PickVoucher.scss';
import { Icon, Divider } from 'antd';
import Button from 'Components/Shared/Button/Button';
import Spinner from 'Components/Shared/Spinner/Spinner';
import InputField from 'Components/Shared/InputField/InputField';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WarningWrapper from 'Components/Shared/WarningWrapper/WarningWrapper';
import { DiscountItems } from 'Components/OrderItemSummary/OrderItemSummary';

interface IProps {
  isFetching: boolean;
  isShowingWarning: boolean;
  discountWeekdayValid: boolean;
  currentInput: string;
  vouchers: Julius.Website.VoucherViewModel[];
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
}

const PickVoucher: React.SFC<IProps> = ({
  isFetching,
  isShowingWarning,
  discountWeekdayValid,
  currentInput,
  vouchers,
  onChange,
  onSubmit,
}) => (
  <div className='pick-voucher'>
    <FormattedText 
      style='title'
      displayName='Presentkort/Kampanjkod'
      formattedName='order.discount.header'  
    />
    <FormattedText 
      style='sub-title'
      displayName='Fyll i koden nedan.'
      formattedName='order.discount.text'  
    />
    { vouchers && vouchers.length > 0 && 
      <>
        <Divider />
        <DiscountItems items={ vouchers }/>
      </>
    }
    { isFetching ?
      <Spinner /> :
      <div className='voucher-form' >
        <InputField
          type='text' 
          value={ currentInput }
          required={ true }
          onChange={ onChange }
        />

        <WarningWrapper 
          isShowingWarning={ isShowingWarning && discountWeekdayValid }
          displayName='Koden är inte giltig'
          formattedName='order.discount.invalid'  
        />
        <WarningWrapper 
          isShowingWarning={ isShowingWarning && !discountWeekdayValid }
          displayName='Gäller ej denna föreställning'
          formattedName='order.discount.weekdayInvalid'  
        />
        <Button onClick={ onSubmit }>
          <Icon type='plus' />
          <FormattedText
            displayName='Lägg till'
            formattedName='order.discount.add'  
          />
        </Button>
        
      </div>
    }
  </div>
);

export default PickVoucher;


// WEBPACK FOOTER //
// ./src/components/PickVoucher/PickVoucher.tsx